import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Item } from 'app/models/item.inferface';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-dialog-description',
  templateUrl: './dialog-description.component.html',
  styleUrls: ['./dialog-description.component.scss']
})
export class DialogDescriptionComponent implements OnInit {
  title: string;
  placeholder: string;
  formControl: FormGroup;
  motivesData: Item[];
  type: 'select' | 'comment';
  maxLength: number;
  constructor(
    @Inject(MAT_DIALOG_DATA) private data,
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    private formBuilder: FormBuilder,
  ) {
    this.maxLength = 4096;
    this.title = data.title;
    this.type = data.type;
    this.placeholder = data.placeholder;
    this.motivesData = data.motivesData;
  }
  ngOnInit(): void {
    if (this.type === 'select') {
      this.formControl = this.formBuilder.group({
        motive: ['', Validators.required],
        comment: ['', [Validators.required, Validators.maxLength(4096)]]
      });
    } else {
      this.formControl = this.formBuilder.group({
        comment: ['', [Validators.required, Validators.maxLength(4096)]]
      });
    }
  }

  onConfirm(): void {
    // Close the dialog, return true
    this.formControl.markAllAsTouched();
    if (this.type === 'select') {
      if (!this.formControl.invalid) {
        const result = {
          motiveId: this.formControl.get('motive').value.id,
          commentData: this.formControl.get('comment').value
        };
        this.dialogRef.close(result);
      }
    } else {
      if (this.formControl.get('comment').value !== '') {
        const result = {
          commentData: this.formControl.get('comment').value
        };
        this.dialogRef.close(result);
      }
    }

  }

  onDismiss(): void {
    // Close the dialog, return false
    this.dialogRef.close(false);
  }

}
